export default __webpack_public_path__ + "static/media/jo.93492209.svg";